import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsHealthcare from '../../../components/video-production/explainer-videos/BenefitsHealthcare';
import ProcessSliderProduct from '../../../components/sliders/ProcessSliderHealthcare';
import SolveProblemsHealthcare from '../../../components/video-production/explainer-videos/SolveProblemsHealthcare';

lazyload({
  width: '100%',
});

const ExplainerVideosHealthcare = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Healthcare Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/healthcare-explainer-video" />
        <meta
          name="description"
          content="Discover the essence of healthcare through our compelling healthcare explainer video. Informative, engaging, and visually captivating. Explore now!"
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/healthcare-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Healthcare Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Discover the essence of healthcare through our compelling healthcare explainer video. Informative, engaging, and visually captivating. Explore now!"
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/healthcare-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "http://schema.org",
  "@type": "WebPage",
  "name": "Video Production - Healthcare Explainer Video | Prodigi",
  "description": "Discover the essence of healthcare through our compelling healthcare explainer video. Informative, engaging, and visually captivating. Explore now!",
  "url": "https://weprodigi.com/video-production/healthcare-explainer-video",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://weprodigi.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Full Service Video Production",
        "item": "https://weprodigi.com/video-production"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Healthcare Expaliner Video Production",
        "item": "https://weprodigi.com/video-production/healthcare-explainer-video"
      }
    ]
  },
  "mainEntity": {
    "@type": "Product",
    "name": "Healthcare Explainer Video Production",
    "description": "Discover the essence of healthcare through our compelling healthcare explainer video. Informative, engaging, and visually captivating. Explore now!",
    "brand": {
      "@type": "Brand",
      "name": "Weprodigi"
    },
    "offers": {
      "@type": "Offer",
      "price": "1300",
      "priceCurrency": "USD",
      "seller": {
        "@type": "Organization",
        "name": "Weprodigi"
      }
    },
    "image": "https://weprodigi.com/images/logovertical.svg",
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Natalie Martinez "
        },
        "datePublished": "2024-01-16",
        "reviewBody": "Prodigi delivered an outstanding healthcare explainer video for our new product launch. Their team's attention to detail and expertise in the medical field ensured our message was communicated effectively. Highly recommend!"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Michael Rodriguez"
        },
        "datePublished": "2024-03-01",
        "reviewBody": "Prodigi's healthcare explainer video captured our brand perfectly. Their team's ability to simplify complex concepts into engaging visuals was impressive. Excellent work!"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4.9",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "David Chaserman"
        },
        "datePublished": "2024-02-25",
        "reviewBody": "Prodigi's healthcare explainer video was exactly what we needed to showcase our services. Their team's professionalism and creativity brought our vision to life. We're thrilled with the outcome!"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "3"
    }
  }
}`,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/healthcare-explainer/healthcare-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Healthcare Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/healthcare-explainer-video',
                name: 'Healthcare Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  Healthcare explainer videos are game changers in the medical and healthcare industry. The patients will stop feeling lost in medical
                  jargon. Let's find out how and why!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a Healthcare Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/vkd6WxV_kVU?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>SAA | 2D Healthcare Explainer</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                Healthcare explainer videos are short, informative videos made to explain complex healthcare subjects clearly and simply. Healthcare
                visualisation is a revolution in patient education. It's a powerful tool for medical campaigns because it simplifies information and
                multi-versatility.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  Healthcare explainer videos are short, informative videos made to explain complex healthcare subjects clearly and simply. Healthcare
                  visualisation is a revolution in patient education. It's a powerful tool for medical campaigns because it simplifies information and
                  multi-versatility.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Healthcare Explainer Video?
            </h2>
            <p className={'mt-20'}>
              Learn how healthcare information videos can be used in different sectors. Here are the main advantages for each industry.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/3hMU6CVCyW0?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Tap’N’Care | 2D Healthcare Explainer</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Health awareness videos are essential additions to your medical marketing techniques. Using these videos in social media, TV ads,
                  and email marketing evaluates your trust-building processes. It brings visibility to your brand and health campaigns. The
                  possibility of using it on various platforms provides better performance to hospital websites and builds trust in the company.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Health awareness videos are essential additions to your medical marketing techniques. Using these videos in social media, TV ads,
                    and email marketing evaluates your trust-building processes. It brings visibility to your brand and health campaigns. The
                    possibility of using it on various platforms provides better performance to hospital websites and builds trust in the company.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Animated healthcare content makes complex medical subjects easier to understand. Healthcare animation videos give clear
                  explanations, leaving a lasting impact. This video format is a creative addition and improvement to your learning processes.
                  Summarise your paragraphs in interactive videos and improve your learning methods.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Animated healthcare content makes complex medical subjects easier to understand. Healthcare animation videos give clear
                    explanations, leaving a lasting impact. This video format is a creative addition and improvement to your learning processes.
                    Summarise your paragraphs in interactive videos and improve your learning methods.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/591ijKm-gPo?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>
                  Community Health Workers | 2D Healthcare Explainer Video
                </p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/fFayQXN7nmE?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Desert Teleheart | Mixed Media Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Public Communication</h3>
                <p className={'mt-16 hidden md:block'}>
                  Communication is the primary key to succeeding in projects for medical, nonprofit, nongovernmental organisations, and health
                  insurance companies. Medical explainer animations or live-action videos simplify communication processes, delivering the primary
                  information your audience needs. Health insurance explainer video improves engagement. Overall, visualised communication speeds up
                  the spreading of public healthcare campaigns.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Communication is the primary key to succeeding in projects for medical, nonprofit, nongovernmental organisations, and health
                    insurance companies. Medical explainer animations or live-action videos simplify communication processes, delivering the primary
                    information your audience needs. Health insurance explainer video improves engagement. Overall, visualised communication speeds up
                    the spreading of public healthcare campaigns.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Healthcare Explainer Videos
            </h2>
            <p className={'mt-20'}>
              Ready to communicate effectively with your potential customers? Do it with benefits that explainer videos for healthcare offer.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsHealthcare />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Healthcare Explainer Video Production Process
            </h2>
            <ProcessSliderProduct />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR HEALTHCARE EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Healthcare Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Explainer video is one of the necessary parts of today’s marketing campaigns. Here are the primary benefits that can be useful for your
              business.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsHealthcare />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Healthcare Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time.',
                  answer:
                    "We know how important our clients' time is. Outsourcing full-service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title: 'We include digital marketing specialists in the production process.',
                  answer:
                    "According to Google, 6 out of 10 people prefer watching videos online rather than TV. To create an effective video, you need to consider which platform the video will be used on and master all its features, be it your website, YouTube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each online platform to get effective material.",
                },
                {
                  title: "We don't require prepayment.",
                  answer:
                    "The client should pay for the work rather than with deposits. We chose a milestone payment option as it's a more trustworthy approach to our work.",
                },
                {
                  title: "We don't have a single unhappy client.",
                  answer:
                    'We never charge for a product that you have not approved. If you are unsatisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'What is the purpose of the healthcare explainer video?',
                    answer: 'A healthcare explainer video aims to enhance patient experience by simplifying medical topics.',
                  },
                  {
                    title: 'What topics will be covered in the healthcare explainer video?',
                    answer: 'There are no topic exceptions to be covered in the healthcare explainer video.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'Can the healthcare explainer video be shared or embedded on other platforms or websites?',
                    answer: 'The versatile format of a healthcare explainer video allows embedding on various platforms and websites.',
                  },
                  {
                    title: 'How long will the healthcare explainer video be?',
                    answer: 'As a rule, a healthcare explainer video lasts from 30 seconds to 3 minutes.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosHealthcare;
